import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const CTASection = () => {
  return (
    <section className="relative overflow-hidden border-y border-border bg-card">
      <div
        className="absolute inset-0 opacity-[0.14] bg-cover bg-center"
        style={{ backgroundImage: "url(/cta-bg.jpeg)" }}
        aria-hidden
      />
      <div className="absolute inset-x-0 top-0 h-px gold-hairline" aria-hidden />

      <div className="container mx-auto px-4 relative z-10 py-20 md:py-28">
        <div className="grid gap-12 lg:grid-cols-[1.25fr_1fr] lg:items-center">
          <div>
            <p className="eyebrow mb-5">Start the conversation</p>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold leading-[1.1] mb-6">
              Your book is the asset.{" "}
              <span className="text-gold-gradient">We build the business around it.</span>
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed max-w-xl mb-9">
              Whether you are staring at a blank page, sitting on a rough manuscript, or holding a
              published book that has gone quiet — there is a next step. Let's find yours in one
              honest conversation.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                asChild
                size="lg"
                className="bg-gold text-gold-foreground hover:bg-gold-light font-semibold text-base px-8"
              >
                <a
                  href="https://meetings.series-a.co/meetings/series-a/authorpro"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2"
                >
                  Book Your Discovery Call
                  <ArrowRight className="w-4 h-4" />
                </a>
              </Button>
              <Button asChild size="lg" variant="outline" className="text-base px-8">
                <Link to="/demo">See It in Action</Link>
              </Button>
            </div>
          </div>

          <div className="grid gap-4">
            {[
              { k: "01", t: "Plan the book", d: "A concept and outline that positions you as the obvious authority." },
              { k: "02", t: "Sharpen the draft", d: "Chapter-level editorial feedback tied to a proven publishing framework." },
              { k: "03", t: "Monetise the work", d: "An interactive platform that turns readers into qualified clients." },
            ].map((row) => (
              <div key={row.k} className="card-noir p-6 flex gap-5 items-start">
                <span className="font-serif italic text-gold text-lg leading-none pt-1">{row.k}</span>
                <div>
                  <h3 className="text-lg font-semibold mb-1">{row.t}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">{row.d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
